import React from "react";

import hasuraBlock from "./images/hasura-block.svg";
import react from "./images/react.svg";
import vue from "./images/vue.svg";
import next from "./images/next.svg";
import typescript from "./images/typescript.svg";
import angular from "./images/angular.svg";
import flutter from "./images/flutter.svg";
import android from "./images/android.svg";
import elm from "./images/elm.png";
import unity from "./images/unity.svg";
import reason from "./images/reason.svg";
import ios from "./images/ios.png";
import rescript from "./images/rescript.png";
import svelte from "./images/svelte.png";
import rxdb from "./images/rxdb.svg";
import postgres from "./images/postgres.svg";
import mysql from "./images/mysql.png";
import mssqlServer from "./images/mssql_server.png";
import graphql from "./images/graphql.svg";
import remix from "./images/remix.svg";
import yugabytedb from "./images/yugabytedb.svg";
import dotnet from "./images/dotnet.svg";
import go from "./images/go.svg";
import java from "./images/java.svg";
import python from "./images/python.svg";
import node from "./images/nodejs.svg";
import database from "./images/database.svg";

const hasuraTutorialState = {
  id: "hasura-tutorials",
  title: "Hasura Tutorials",
  desc: "Our courses on Hasura will take you from the basics (where you learn how to run Hasura in just 30 minutes) to advanced concepts that teach you how to optimize your applications.",
  graphqlDesc:
    "We have four courses on Hasura that will cover basic concepts as well as advanced topics on optimizing applications.",
  learnList: [
    "Setting up GraphQL API from scratch",
    "Write custom GraphQL server with Apollo and Node js",
    "Best practices for using Hasura to build web applications",
    "Authorization and Authentication example using GraphQL",
    "Convert a REST API to GraphQL API using Hasura Actions",
    "Leverage database features",
    "Write GraphQL schema and types and map them to REST APIs.",
  ],
  isOpenDesc: true,
  learnCourse: [
    {
      imgSrc: hasuraBlock,
      courseName: "Hasura Basics - v2",
      courseLink: "https://hasura.io/learn/graphql/hasura/introduction/",
    },
    // {
    //   imgSrc: hasuraBlock,
    //   courseName: "Hasura Basics - v3",
    //   courseLink: "https://hasura.io/learn/graphql/hasura-v3/introduction/",
    // },
    {
      imgSrc: hasuraBlock,
      courseName: "Authorization Patterns with Hasura",
      courseLink: "https://hasura.io/learn/graphql/hasura-auth-slack/introduction/",
    },
    {
      imgSrc: hasuraBlock,
      courseName: "Hasura Authentication",
      courseLink: "https://hasura.io/learn/graphql/hasura-authentication/introduction/",
    },
    {
      imgSrc: hasuraBlock,
      courseName: "Hasura Advanced",
      courseLink: "https://hasura.io/learn/graphql/hasura-advanced/introduction/",
    },
    // {
    //   imgSrc: hasuraBlock,
    //   courseName: `Hasura v3 Supergraph`,
    //   courseLink: `https://hasura.io/learn/graphql/hasura-v3-supergraph/introduction/`,
    // },
    // {
    //   imgSrc: hasuraBlock,
    //   courseName: `Hasura v3 TS Connector`,
    //   courseLink: `https://hasura.io/learn/graphql/hasura-v3-ts-connector/introduction/`,
    // },
  ],
};

const frontendTutorialState = {
  id: "front-end-tutorials",
  title: "Frontend GraphQL Tutorials",
  desc: "You'll find that in every chapter, and all of our GraphQL tutorials and articles on our website, we'll cover the following concepts time and again:",
  graphqlDesc:
    "We have 13 courses on using GraphQL with the most commonly used front-end frameworks that cover topics such as GraphQL vs REST, queries, mutations, subscriptions, and more.",
  learnList: [
    "GraphQL vs. REST",
    "Realtime feed with notifications.",
    "Integrating GraphQL Mutations with Query Variables.",
    "GraphQL Queries, Mutations, Subscriptions.",
    "Using Subscriptions with Apollo Client.",
    "Integrating Mutations to update, delete and bulk delete.",
    "Setting up a GraphQL client with Apollo.",
    "Integrating GraphQL queries in the app.",
    "Managing Local Cache after a Mutation.",
    "Optimistic UI updates for responsive user experience.",
  ],
  isOpenDesc: true,
  learnCourse: [
    {
      imgSrc: react,
      courseName: "GraphQL with React",
      courseLink: "https://hasura.io/learn/graphql/react/introduction/",
    },
    {
      imgSrc: vue,
      courseName: "GraphQL with Vue",
      courseLink: "https://hasura.io/learn/graphql/vue/introduction/",
    },
    {
      imgSrc: typescript,
      courseName: "GraphQL with TypeScript",
      courseLink: "https://hasura.io/learn/graphql/typescript-react-apollo/introduction/",
    },
    {
      imgSrc: react,
      courseName: "GraphQL with React Native",
      courseLink: "https://hasura.io/learn/graphql/react-native/introduction/",
    },
    {
      imgSrc: angular,
      courseName: "GraphQL with Angular",
      courseLink: "https://hasura.io/learn/graphql/angular-apollo/introduction/",
    },
    {
      imgSrc: flutter,
      courseName: "GraphQL with Flutter",
      courseLink: "https://hasura.io/learn/graphql/flutter-graphql/introduction/",
    },
    {
      imgSrc: android,
      courseName: "GraphQL with Android",
      courseLink: "https://hasura.io/learn/graphql/android/introduction/",
    },
    {
      imgSrc: elm,
      courseName: "GraphQL with Elm",
      courseLink: "https://hasura.io/learn/graphql/elm-graphql/introduction/",
    },
    {
      imgSrc: unity,
      courseName: "GraphQL with Unity",
      courseLink: "https://hasura.io/learn/graphql/unity/introduction/",
    },
    {
      imgSrc: reason,
      courseName: "GraphQL with ReasonML",
      courseLink: "https://hasura.io/learn/graphql/reason-react-apollo/introduction/",
    },
    {
      imgSrc: ios,
      courseName: "GraphQL with iOS",
      courseLink: "https://hasura.io/learn/graphql/ios/introduction/",
    },
    {
      imgSrc: rescript,
      courseName: "GraphQL with ReScript",
      courseLink: "https://hasura.io/learn/graphql/rescript-react-apollo/introduction/",
    },
    {
      imgSrc: svelte,
      courseName: "GraphQL with Svelte",
      courseLink: "https://hasura.io/learn/graphql/svelte-apollo/introduction/",
    },
    {
      imgSrc: remix,
      courseName: "GraphQL with Remix",
      courseLink: "https://hasura.io/learn/graphql/remix-fullstack-firebase/introduction/",
    },
    {
      imgSrc: database,
      courseName: "GraphQL with VectorDBs",
      courseLink: "https://hasura.io/learn/graphql/vectordbs/introduction/",
    },
  ],
};

const backendTutorialState = {
  id: "backend-end-tutorials",
  title: "Backend GraphQL Tutorials",
  desc: "Create GraphQL and REST backends with a language's latest features and libraries. Easily integrate with Hasura features such as event triggers, actions, and remote schemas.",
  graphqlDesc:
    "We have five courses with various languages on creating GraphQL servers/clients and REST endpoints.",
  learnList: [
    "Creating GraphQL servers and clients",
    "Making REST endpoints",
    "Fully use the language's type system",
    "Download and utilize dependencies",
    "Code generation with supported languages",
    "Integrate with Hasura",
  ],
  isOpenDesc: true,
  learnCourse: [
    {
      imgSrc: dotnet,
      courseName: "GraphQL with .NET",
      courseLink: "https://hasura.io/learn/graphql/backend-stack/languages/dotnet/",
      courseDesc:
        "In our .NET course we use the .NET standard library to create REST endpoints, create a GraphQL server with Hot Chocolate, and query GraphQL Strawberry Shake.",
      courseDescOpen: true,
    },
    {
      imgSrc: go,
      courseName: "GraphQL with Go",
      courseLink: "https://hasura.io/learn/graphql/backend-stack/languages/go/",
      courseDesc:
        "The Go course covers code-generating a GraphQL server and client. We also go over how to create REST endpoints with the standard library.",
      courseDescOpen: true,
    },
    {
      imgSrc: java,
      courseName: "GraphQL with Java",
      courseLink: "https://hasura.io/learn/graphql/backend-stack/languages/java/",
      courseDesc:
        "Using Java, Spring Boot, and Netflix's DGS we create REST endpoints, a GraphQL server, and a GraphQL client. Dependencies are managed with Gradle.",
      courseDescOpen: true,
    },
    {
      imgSrc: node,
      courseName: "GraphQL with Node",
      courseLink: "https://hasura.io/learn/graphql/backend-stack/languages/node/",
      courseDesc:
        "Using Node, Express, and TypeScript we create REST endpoints and generate a GraphQL server/client with GraphQL Code Generator.",
      courseDescOpen: true,
    },
    {
      imgSrc: python,
      courseName: "GraphQL with Python",
      courseLink: "https://hasura.io/learn/graphql/backend-stack/languages/python/",
      courseDesc:
        "In the Python course we cover creating REST endpoints using FastAPI, making a GraphQL server with Strawberry, and querying GraphQL with Qlient.",
      courseDescOpen: true,
    },
  ],
};

const fullstackTutorialState = {
  id: "fullstack-tutorials",
  title: "Full-stack GraphQL Tutorials",
  desc: "The following fullstack GraphQL tutorials will teach you how to build realtime todo apps using authenticated GraphQL APIs",
  graphqlDesc:
    "We have 2 full-stack GraphQL tutorials on building real-time todo apps using authenticated GraphQL APIs.",
  isOpenDesc: true,
  learnCourse: [
    {
      imgSrc: next,
      courseName: "GraphQL with NextJS",
      courseLink: "https://hasura.io/learn/graphql/nextjs-fullstack-serverless/introduction/",
      courseDesc:
        "In this fullstack tutorial, we will look at building a Hasura GraphQL Backend to generate APIs, followed by integration with Next.js app. We'll be using Auth0 for the Authentication and Vercel for deployment.",
      courseDescOpen: true,
    },
    {
      imgSrc: rxdb,
      courseName: "RxDB Offline First Tutorial",
      courseLink: "https://hasura.io/learn/graphql/react-rxdb-offline-first/introduction/",
      courseDesc:
        "In this course, we will look at how to make a web app offline first using a client-side database that is synced securely with Postgres. We'll be using two open-source tools, RxDB and Hasura to help set up the sync. We will be using Auth0 for Authentication though other tools like Firebase, AWS Cognito or AuthGuardian should also work perfectly well.",
      courseDescOpen: true,
    },
  ],
};

const databaseTutorialState = {
  id: "database-tutorials",
  title: "Database Tutorials",
  desc: "The following database tutorials will teach you core concepts around data modelling with examples of SQL statements",
  graphqlDesc:
    "Hasura gives you GraphQL and REST APIs over data sources such as databases like PostgreSQL, SQL Server, and BigQuery. The Hasura community requested that we also delve into these types of courses to help out the front-end developer. These database tutorials will cover core concepts around data modeling with examples of SQL statements.",
  isOpenDesc: true,
  learnCourse: [
    {
      imgSrc: postgres,
      courseName: "PostgreSQL Tutorial",
      courseLink: "https://hasura.io/learn/database/postgresql/introduction/",
      courseDesc:
        "This tutorial will help you understand the different PostgreSQL features, when and how to use them, and is an ideal starting point before diving into advanced topics.",
      courseDescOpen: true,
    },
    {
      imgSrc: mysql,
      courseName: "MySQL Tutorial",
      courseLink: "https://hasura.io/learn/database/mysql/introduction/",
      courseDesc:
        "This course is a super-fast introduction to learning about key concepts of MySQL and setting it up for app development.",
      courseDescOpen: true,
    },
    {
      imgSrc: mssqlServer,
      courseName: "Microsoft SQL Server",
      courseLink: "https://hasura.io/learn/database/microsoft-sql-server/introduction/",
      courseDesc:
        "This course is designed to help you understand the key features of MSSQL server, when and how to use them, and will lay a foundation for you to learn advanced concepts.",
      courseDescOpen: true,
    },
    // {
    //   imgSrc: yugabytedb,
    //   courseName: "YugabyteDB Tutorial",
    //   courseLink: "https://hasura.io/learn/database/yugabyte/introduction/",
    //   courseDesc:
    //     "This tutorial will help you set up YugabyteDB and Hasura on a cloud-native environment and the connection between the two for making GraphQL queries on a geo-distributed DB.",
    //   courseDescOpen: true,
    // },
  ],
};

const introGraphQLState = {
  id: "intro-to-graphql",
  title: "Introduction to GraphQL",
  desc: "GraphQL is open source and is maintained by the Linux Foundation. GraphQL API has a schema and type system. Learn more about the fundamentals of GraphQL through the resources listed below.",
  graphqlDesc: (
    <span>
      Our Introduction to GraphQL Course is the perfect place to start if you’re beginning your
      GraphQL journey.
      <br />
      <br />
      This tutorial will take you through to the basics of what is GraphQL, the differences between
      GraphQL and REST, core concepts of what a GraphQL document is and what an operation looks
      like, all the way to concepts around introspection, queries, mutations, subscriptions, GraphQL
      servers, and clients.
    </span>
  ),
  isOpenDesc: true,
  removeBor: true,
  learnCourse: [
    {
      imgSrc: graphql,
      courseName: "Introduction to GraphQL",
      courseLink: "https://hasura.io/learn/graphql/intro-graphql/introduction/",
    },
  ],
};

export {
  frontendTutorialState,
  fullstackTutorialState,
  databaseTutorialState,
  introGraphQLState,
  backendTutorialState,
};
